import { useEffect, useState } from 'react';
import { DocumentComment } from '../../../../../hoc/common/documents/types';
import {
  useDeleteCustomersCommentMutation,
  useEditCustomersCommentMutation,
} from '../../../../../store/documents/services';

const useComment = ({ comment }: { comment: DocumentComment }) => {
  const [edit, setEdit] = useState(false);
  const [text, setText] = useState(comment?.text);

  const [editComment, { isLoading, isSuccess }] =
    useEditCustomersCommentMutation();
  const [deleteComment, { isLoading: deleteInProgress }] =
    useDeleteCustomersCommentMutation();

  useEffect(() => {
    if (comment) {
      setText(comment?.text);
    }
  }, [comment]);

  useEffect(() => {
    if (isSuccess) {
      setEdit(false);
    }
  }, [isSuccess]);

  return {
    edit,
    setEdit,
    deleteComment,
    deleteInProgress,
    text,
    setText,
    isLoading,
    editComment,
  };
};

export default useComment;
